import React from "react";
export default function NotFound() {
  return (
    <div style={{ padding: 20 }}>
      <h1>404</h1>
    </div>
  );
}
